module.exports = __webpack_public_path__ + "static/media/home-event2.0719aca9.jpeg";